import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { Store } from '@/types/ProductType'

export const useMarketsCompareStore = defineStore('marketsCompare', () => {
  const marketsToCompareList = ref<Store[]>([])

  const addMarketToCompare = (market: Store) => {
    marketsToCompareList.value.push(market)
  }

  const removeMarketFromCompare = (market: Store) => {
    marketsToCompareList.value = marketsToCompareList.value.filter(
      (marketItem) => marketItem.general_info.store_name !== market.general_info.store_name
    )
  }

  const clearMarketsFromCompare = () => {
    marketsToCompareList.value = []
  }

  return {
    marketsToCompareList,
    addMarketToCompare,
    removeMarketFromCompare,
    clearMarketsFromCompare
  }
})

